import { Component, Prop, Vue } from 'vue-property-decorator';
import { ReferralCreditLog } from '@/models/User';

@Component<ReferralCreditLogDatatable>({})
export default class ReferralCreditLogDatatable extends Vue {
  @Prop({ required: true })
  protected logs!: ReferralCreditLog[];

  protected get items() {
    return this.logs;
  }

  protected get headers() {
    return [
      {
        text: 'Order',
        value: 'referral_code_order',
        sortable: false,
      },
      {
        text: 'Credit before',
        value: 'credit_before',
        sortable: false,
      },
      {
        text: 'Credit after',
        value: 'credit_after',
        sortable: false,
      },
      {
        text: 'Date',
        value: 'created_at',
        sortable: false,
      },
    ]
  }
}

